import React from "react";
import { UiComponents } from "@simulanisindia/ui";

const PermissionHeader = ({ search, setSearch }) => {
  const { SearchBar } = UiComponents;
  return (
    <>
      <div className="permissions-header">
        <div className="permissions-heading">
          <h5>Manage Permissions</h5>
          <p>Select the permissions you want to assign to an individual</p>
        </div>
        {/* <div className="searchwithborder ">
          <SearchBar value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search...." />
        </div> */}
      </div>
    </>
  );
};

export default PermissionHeader;
